import React from 'react';
import './TrustBadges.css';

const TrustBadges = ({ layout = 'horizontal' }) => {
  const badges = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="28" height="28">
          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      ),
      title: 'Original Artwork',
      subtitle: '100% Hand-painted'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="28" height="28">
          <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
        </svg>
      ),
      title: 'Certificate',
      subtitle: 'Of Authenticity'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="28" height="28">
          <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
        </svg>
      ),
      title: 'Secure Shipping',
      subtitle: 'Across India'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="28" height="28">
          <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      ),
      title: '2-4 Weeks',
      subtitle: 'For Custom Orders'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="28" height="28">
          <path d="M3 10h18M7 15h1m4 0h1m-7 4h1m4 0h1m-7-8h1m4 0h1M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
        </svg>
      ),
      title: 'UPI / Cards / COD',
      subtitle: 'Flexible Payments'
    }
  ];

  return (
    <div className={`trust-badges trust-badges--${layout}`} aria-label="Trust and guarantee badges">
      {badges.map((badge, index) => (
        <div key={index} className="trust-badge">
          <div className="trust-badge-icon">{badge.icon}</div>
          <div className="trust-badge-text">
            <span className="trust-badge-title">{badge.title}</span>
            <span className="trust-badge-subtitle">{badge.subtitle}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;
